import React from "react";
import { Accordion, Card, Col, Form } from "react-bootstrap";
import { IoMdCheckmark } from "react-icons/io";
import { MdCheckCircle, MdCancel } from "react-icons/md";

import {
  contractorDropdownLabel,
  employeeDropdownLabel,
  userDropdownLabel,
} from "app/_helpers/helper";
import {
  incidentStatuses,
  incidentTypes,
  progressWithIncidentStatus,
  severities,
} from "./CONSTANTS";
import { CgSandClock } from "react-icons/cg";
import { Row } from "react-bootstrap";
import CustomPopover from "app/Components/CommanComponents/CustomPopover";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { isArray } from "lodash";
import { DDMMYYYYFormat, DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";

const IncidentTimeline = ({
  reporter,
  reportDate,
  reviewCompletionDate,
  reviewedDate,
  closureCompletionDate,
  investigationCompletionDate,
  investigationDetails,
  closer,
  reviewer,
  investigationCompleted,
  reviewCompleted,
  closureCompleted,
  isPersonalInjury,
  isAssetIncident,
  isVehicleIncident,
  isSpillsIncident,
  incidentStatus,
  insuranceApplicable,
  complianceRequired,
  trainingRequired,
  witnessStatementRequired,
  rootCauseAnalysisRequired,
  solutionRequired,
  capaRequired,
  reportEvidencesRequired,
  evidencesRequired,
  reviewEvidencesRequired,
  incidentDate,
  incidentId,
  type,
  severity,
  severityPostReview,
  area,
  site,
  department,
  isCapaPresent,
  targetCompletionDate,
  capaCompletionDate,
  capaCompletedByData,
  finalReviewedByData,
  finalReviewedByDate,
  reviewedByMMData,
  reviewedByMMDate,
  staffData,
  staffType,
  otherStaffName,
  capasList,
  reportAtLabel,
  capaTimeLine,
  form,
}) => (
  <div className="card p-3  pb-0 mt-4">
    <Row>
      <Col lg={capaTimeLine ? 6 : 8}>
        <Accordion defaultActiveKey="1" className="timeline pl-4">
          <div className="timelineSection completedtimelineSection">
            <Accordion.Toggle as={Card.Header} eventKey={"1"}>
              <div className={`number completednumber`}>{<IoMdCheckmark />}</div>
              <h4>Incident Reported</h4>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <div className="px-4 pt-0 timelineText">
                <ul className="list-inline d-flex">
                  <li>
                    <div className="timelineRow">
                      <h5 className="txtgrey">Reported Date</h5>
                      <h5>{DDMMYYYYHHMMAFormat(reportDate)}</h5>
                    </div>
                    <div className="timelineRow">
                      <h5 className="txtgrey">Reported By</h5>
                      <h5>
                        {staffType === "employee"
                          ? `${employeeDropdownLabel(staffData)}`
                          : staffType === "contractor"
                          ? `${contractorDropdownLabel(staffData)}`
                          : otherStaffName}
                      </h5>
                    </div>
                    <div className="timelineRow">
                      <h5 className="txtgrey">Reporting Officer</h5>
                      <h5>{userDropdownLabel(reporter)}</h5>
                    </div>
                  </li>
                  <IncidetnReportedRightData
                    isPersonalInjury={isPersonalInjury}
                    isAssetIncident={isAssetIncident}
                    isVehicleIncident={isVehicleIncident}
                    reportEvidencesRequired={reportEvidencesRequired}
                    isCapaPresent={isCapaPresent}
                    capaCompletionDate={capaCompletionDate}
                    incidentStatus={incidentStatus}
                  />
                </ul>
              </div>
            </Accordion.Collapse>
          </div>
          {(incidentStatus === incidentStatuses.open ||
            incidentStatus === incidentStatuses.draft ||
            reviewedDate) && (
            <div className="timelineSection completedtimelineSection">
              <Accordion.Toggle as={Card.Header} eventKey={reviewedDate ? "2" : "0"}>
                <div
                  className={`number ${
                    reviewedDate ? "completednumber" : "notstrtednumber"
                  }${incidentStatus === incidentStatuses.open ? " bg-warning" : ""}`}
                >
                  {reviewedDate ? <IoMdCheckmark /> : 2}
                </div>
                <h4>Safety Officer Review</h4>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="2">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Review Date</h5>
                        <h5>{DDMMYYYYHHMMAFormat(reviewedDate)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Review By</h5>
                        <h5>{userDropdownLabel(reviewer)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>
          )}
          {(severity > 3 || reviewedByMMDate) && (
            <div className="timelineSection completedtimelineSection">
              <Accordion.Toggle as={Card.Header} eventKey={reviewedByMMDate ? "3" : "0"}>
                <div
                  className={`number ${
                    reviewedByMMDate ? "completednumber" : "notstrtednumber"
                  }${incidentStatus === incidentStatuses.mmReview ? " bg-warning" : ""}`}
                >
                  {reviewedByMMDate ? <IoMdCheckmark /> : 3}
                </div>
                <h4>Mines Manager Review</h4>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="3">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Review Date</h5>
                        <h5>{DDMMYYYYHHMMAFormat(reviewedByMMDate)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Review By</h5>
                        <h5>{userDropdownLabel(reviewedByMMData)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>
          )}
          {((incidentStatus === incidentStatuses.investigationProgress && severity > 3) ||
            (investigationCompletionDate && severity > 3)) && (
            <div className="timelineSection completedtimelineSection">
              <Accordion.Toggle
                as={Card.Header}
                eventKey={investigationCompleted ? "4" : "0"}
              >
                <div
                  className={`number ${
                    investigationCompleted ? "completednumber" : "notstrtednumber"
                  }${
                    incidentStatus === incidentStatuses.investigationProgress
                      ? " bg-warning"
                      : ""
                  }`}
                >
                  {investigationCompleted ? <IoMdCheckmark /> : 4}
                </div>
                <h4>Investigation</h4>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="4">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Completion Date</h5>
                        <h5>{DDMMYYYYHHMMAFormat(investigationCompletionDate)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Investigated By</h5>
                        <h5>{userDropdownLabel(investigationDetails?.investigator)}</h5>
                      </div>
                      {/* <div className="timelineRow">
                                                <h5 className="txtgrey">Target Date</h5>
                                                <h5>{DDMMYYYYHHMMAFormat(targetCompletionDate)}</h5>
                                            </div> */}
                    </li>
                    <InvestigationRightData
                      witnessStatementRequired={witnessStatementRequired}
                      rootCauseAnalysisRequired={rootCauseAnalysisRequired}
                      capaRequired={capaRequired}
                      evidencesRequired={evidencesRequired}
                      investigationCompletionDate={investigationCompletionDate}
                      incidentStatus={incidentStatus}
                    />
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>
          )}
          {((reportAtLabel !== "Reporting Officer" &&
            incidentStatus === incidentStatuses.closed) ||
            incidentStatus !== incidentStatuses.closed) && (
            <div className="timelineSection completedtimelineSection">
              <Accordion.Toggle
                as={Card.Header}
                eventKey={capaCompletionDate ? "5" : "0"}
              >
                <div
                  className={`number ${
                    capaCompletionDate ? "completednumber" : "notstrtednumber"
                  }${
                    incidentStatus === incidentStatuses.capaAssigned ? " bg-warning" : ""
                  }`}
                >
                  {capaCompletionDate ? (
                    <IoMdCheckmark />
                  ) : ((incidentStatus === incidentStatuses.investigationProgress &&
                      severity > 3) ||
                      (investigationCompletionDate && severity > 3)) &&
                    reviewedByMMDate &&
                    severity > 3 ? (
                    5
                  ) : reviewedByMMDate || severity > 3 ? (
                    4
                  ) : (
                    3
                  )}
                </div>
                <h4>CAPA</h4>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="5">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">
                          Completion Date&nbsp;
                          <CustomPopover
                            placement={"right"}
                            tooltip={
                              <>
                                <table className="table table-bordered tooltipTable">
                                  <thead>
                                    <tr>
                                      <th>CAPA ID</th>
                                      <th>Owner</th>
                                      <th>Completion Date</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {isArray(capasList) &&
                                      capasList.map((data) => {
                                        return (
                                          <tr>
                                            <td>{data.capaId}</td>
                                            <td>
                                              {data.owner?.firstName}{" "}
                                              {data.owner?.lastName}
                                            </td>
                                            <td>
                                              {DDMMYYYYHHMMAFormat(data.completionDate)}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                </table>
                              </>
                            }
                          >
                            <BsFillInfoCircleFill />
                          </CustomPopover>
                        </h5>
                        <h5>{DDMMYYYYHHMMAFormat(capaCompletionDate)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Completed By</h5>
                        <h5>{userDropdownLabel(capaCompletedByData)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>
          )}
          {((incidentStatus === incidentStatuses.closed && finalReviewedByDate) ||
            incidentStatus !== incidentStatuses.closed) && (
            <div className="timelineSection completedtimelineSection">
              <Accordion.Toggle
                as={Card.Header}
                eventKey={finalReviewedByDate ? "6" : "0"}
              >
                <div
                  className={`number ${
                    finalReviewedByDate ? "completednumber" : "notstrtednumber"
                  }${
                    incidentStatus === incidentStatuses.initialReview ? " bg-warning" : ""
                  }`}
                >
                  {finalReviewedByDate ? (
                    <IoMdCheckmark />
                  ) : ((incidentStatus === incidentStatuses.investigationProgress &&
                      severity > 3) ||
                      (investigationCompletionDate && severity > 3)) &&
                    reviewedByMMDate &&
                    severity > 3 ? (
                    6
                  ) : reviewedByMMDate || severity > 3 ? (
                    5
                  ) : (
                    4
                  )}
                </div>
                <h4>Final Review</h4>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="6">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Review Date</h5>
                        <h5>{DDMMYYYYHHMMAFormat(finalReviewedByDate)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Reviewed By</h5>
                        <h5>{reportAtLabel}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Reviewer Name</h5>
                        <h5>{userDropdownLabel(finalReviewedByData)}</h5>
                      </div>
                    </li>
                    <li className="secInfo ml-5 pl-5">
                      <h5>
                        <span
                          style={
                            reviewEvidencesRequired !== null
                              ? { color: "green" }
                              : undefined
                          }
                        >
                          Evidence
                        </span>
                        <span
                          className={`text-${
                            reviewEvidencesRequired === null
                              ? ""
                              : reviewEvidencesRequired
                              ? "success"
                              : "danger"
                          }`}
                          style={
                            reviewEvidencesRequired === null
                              ? { color: "#2bb0e5" }
                              : undefined
                          }
                        >
                          {reviewEvidencesRequired === null ? (
                            <CgSandClock />
                          ) : reviewEvidencesRequired ? (
                            <MdCheckCircle />
                          ) : (
                            <MdCancel />
                          )}
                        </span>
                      </h5>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>
          )}
          <div
            className={`timelineSection ${
              !form?.ltiHoursUpdate
                ? "pendingtimelineSection lastTimeLine"
                : "completedtimelineSection"
            }`}
          >
            <Accordion.Toggle
              as={Card.Header}
              eventKey={closureCompleted || reviewCompleted ? "7" : "0"}
            >
              <div
                className={`number ${
                  closureCompleted ? "completednumber" : "notstrtednumber"
                }${incidentStatus === incidentStatuses.finalReview ? " bg-warning" : ""}`}
              >
                {closureCompleted ? (
                  <IoMdCheckmark />
                ) : ((incidentStatus === incidentStatuses.investigationProgress &&
                    severity > 3) ||
                    (investigationCompletionDate && severity > 3)) &&
                  reviewedByMMDate &&
                  severity > 3 ? (
                  7
                ) : reviewedByMMDate || severity > 3 ? (
                  6
                ) : (
                  5
                )}
              </div>
              <h3>Incident Closed</h3>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="7">
              <div className="px-4 pt-0 timelineText">
                <ul className="list-inline d-flex">
                  <li>
                    <div className="timelineRow">
                      <h5 className="txtgrey">Date</h5>
                      <h5>{DDMMYYYYHHMMAFormat(closureCompletionDate)}</h5>
                    </div>
                    <div className="timelineRow">
                      <h5 className="txtgrey">Approved By</h5>
                      <h5>{reportAtLabel}</h5>
                    </div>
                    <div className="timelineRow">
                      <h5 className="txtgrey">Approver Name</h5>
                      <h5>{userDropdownLabel(closer)}</h5>
                    </div>
                  </li>
                </ul>
              </div>
            </Accordion.Collapse>
          </div>
          {form?.ltiHoursUpdate ? <LtiInformation form={form} /> : ""}
        </Accordion>
      </Col>
      {capaTimeLine && (
        <Col lg={3}>
          {isArray(capasList) && capasList?.length !== 0 && (
            <table className="table table-bordered tooltipTable timelineTable">
              <thead>
                <tr>
                  <th>CAPA ID</th>
                  <th>Owner</th>
                  <th>Completion Date</th>
                </tr>
              </thead>
              <tbody>
                {isArray(capasList) &&
                  capasList.map((data) => {
                    return (
                      <tr>
                        <td>{data.capaId}</td>
                        <td>
                          {data.owner?.firstName} {data.owner?.lastName}
                        </td>
                        <td>{DDMMYYYYHHMMAFormat(data.completionDate)}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          )}
        </Col>
      )}
      <Col lg={capaTimeLine ? 3 : 4}>
        <div className="timelineText mt-3">
          <ul className="list-inline d-flex">
            <li className="secInfo ml-4 pl-4">
              <div className="timelineRow py-1">
                <h5 className="txtgrey mb-1">Incident ID</h5>
                <h5 className="mb-1">{incidentId}</h5>
              </div>
              <div className="timelineRow py-1">
                <h5 className="txtgrey mb-1">Incident Date</h5>
                <h5 className="mb-1">{DDMMYYYYHHMMAFormat(incidentDate)}</h5>
              </div>
              <div className="timelineRow py-1">
                <h5 className="txtgrey mb-1">Incident Type</h5>
                <h5 className="mb-1">{incidentTypes[type]}</h5>
              </div>
              <div className="timelineRow py-1">
                <h5 className="txtgrey mb-1">Severity (Reported)</h5>
                <h5 className="mb-1">{severities[severity]}</h5>
              </div>
              {/* <div className="timelineRow py-1">
                                <h5 className="txtgrey mb-1">Severity (Post Review)</h5>
                                <h5 className="mb-1">{severities[severityPostReview] || "(NA)"}</h5>
                            </div> */}
              <div className="timelineRow py-1">
                <h5 className="txtgrey mb-1">Area Of Operation</h5>
                <h5 className="mb-1">{area?.name}</h5>
              </div>
              <div className="timelineRow py-1">
                <h5 className="txtgrey mb-1">Location</h5>
                <h5 className="mb-1">{site?.name}</h5>
              </div>
              <div className="timelineRow py-1">
                <h5 className="txtgrey mb-1">Department</h5>
                <h5 className="mb-1">{department?.name}</h5>
              </div>
              <div className="timelineRow py-1">
                <h5 className="txtgrey mb-1">Reported By</h5>
                <h5 className="mb-1">
                  {staffType === "employee"
                    ? `${employeeDropdownLabel(staffData)}`
                    : staffType === "contractor"
                    ? `${contractorDropdownLabel(staffData)}`
                    : otherStaffName}
                </h5>
              </div>
              <div className="timelineRow py-1">
                <h5 className="txtgrey mb-1">Reporting Officer</h5>
                <h5 className="mb-1">{userDropdownLabel(reporter)}</h5>
              </div>
              <div className="timelineRow py-1">
                <h5 className="txtgrey mb-1">Status</h5>
                <h5 className="mb-1">{incidentStatus}</h5>
              </div>
            </li>
          </ul>
        </div>
      </Col>
    </Row>
  </div>
);

export default IncidentTimeline;

export const LtiInformation = ({ form }) => {
  return (
    <div className="timelineSection pendingtimelineSection lastTimeLine">
      <Accordion.Toggle as={Card.Header} eventKey={"lti_0"}>
        <div className={`number ${"completednumber"}`}>{<IoMdCheckmark />}</div>
        <h4>LTI Information Updated</h4>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey="lti_0">
        <div className="px-4 pt-0 timelineText">
          <ul className="list-inline d-flex">
            <li>
              <div className="timelineRow">
                <h5 className="txtgrey">Updated Date</h5>
                <h5>
                  {form?.ltiHoursUpdatedAt ? DDMMYYYYFormat(form?.ltiHoursUpdatedAt) : ""}
                </h5>
              </div>
              <div className="timelineRow">
                <h5 className="txtgrey">Updated By</h5>
                <h5>{userDropdownLabel(form?.ltiHoursUpdatedByData)}</h5>
              </div>
            </li>
          </ul>
        </div>
      </Accordion.Collapse>
    </div>
  );
};

export const IncidetnReportedRightData = ({
  isPersonalInjury,
  isAssetIncident,
  isVehicleIncident,
  reportEvidencesRequired,
  isCapaPresent,
  incidentStatus,
  capaCompletionDate,
}) => {
  const PROGRESS_BY_STATUS = progressWithIncidentStatus.includes(incidentStatus)
    ? true
    : false;
  const PROGRESS_CAPA = !!(
    !capaCompletionDate && incidentStatus !== incidentStatuses.closed
  );
  return (
    <li className="secInfo ml-5 pl-5">
      <h5>
        <span style={PROGRESS_BY_STATUS ? undefined : { color: "green" }}>
          Incident Details
        </span>{" "}
        <span
          className={`text-${PROGRESS_BY_STATUS ? "" : "success"}`}
          style={PROGRESS_BY_STATUS ? { color: "#2bb0e5" } : undefined}
        >
          {PROGRESS_BY_STATUS ? <CgSandClock /> : <MdCheckCircle />}
        </span>
      </h5>
      <h5>
        <span
          style={!PROGRESS_BY_STATUS && isPersonalInjury ? { color: "green" } : undefined}
        >
          Personnel Details
        </span>
        <span
          className={`text-${
            PROGRESS_BY_STATUS
              ? ""
              : !PROGRESS_BY_STATUS && isPersonalInjury
              ? "success"
              : "danger"
          }`}
          style={PROGRESS_BY_STATUS ? { color: "#2bb0e5" } : undefined}
        >
          {PROGRESS_BY_STATUS ? (
            <CgSandClock />
          ) : !PROGRESS_BY_STATUS && isPersonalInjury ? (
            <MdCheckCircle />
          ) : (
            <MdCancel />
          )}
        </span>
      </h5>
      <h5>
        <span
          style={!PROGRESS_BY_STATUS && isAssetIncident ? { color: "green" } : undefined}
        >
          Equipment/Asset Details
        </span>
        <span
          className={`text-${
            PROGRESS_BY_STATUS
              ? ""
              : !PROGRESS_BY_STATUS && isAssetIncident
              ? "success"
              : "danger"
          }`}
          style={PROGRESS_BY_STATUS ? { color: "#2bb0e5" } : undefined}
        >
          {PROGRESS_BY_STATUS ? (
            <CgSandClock />
          ) : !PROGRESS_BY_STATUS && isAssetIncident ? (
            <MdCheckCircle />
          ) : (
            <MdCancel />
          )}
        </span>
      </h5>
      <h5>
        <span
          style={
            !PROGRESS_BY_STATUS && isVehicleIncident ? { color: "green" } : undefined
          }
        >
          Vehicle Details
        </span>
        <span
          className={`text-${
            PROGRESS_BY_STATUS
              ? ""
              : !PROGRESS_BY_STATUS && isVehicleIncident
              ? "success"
              : "danger"
          }`}
          style={PROGRESS_BY_STATUS ? { color: "#2bb0e5" } : undefined}
        >
          {PROGRESS_BY_STATUS ? (
            <CgSandClock />
          ) : !PROGRESS_BY_STATUS && isVehicleIncident ? (
            <MdCheckCircle />
          ) : (
            <MdCancel />
          )}
        </span>
      </h5>
      <h5>
        <span
          style={
            !PROGRESS_BY_STATUS && reportEvidencesRequired
              ? { color: "green" }
              : undefined
          }
        >
          Incident Evidence
        </span>
        <span
          className={`text-${
            PROGRESS_BY_STATUS
              ? ""
              : !PROGRESS_BY_STATUS && reportEvidencesRequired
              ? "success"
              : "danger"
          }`}
          style={PROGRESS_BY_STATUS ? { color: "#2bb0e5" } : undefined}
        >
          {PROGRESS_BY_STATUS ? (
            <CgSandClock />
          ) : !PROGRESS_BY_STATUS && reportEvidencesRequired ? (
            <MdCheckCircle />
          ) : (
            <MdCancel />
          )}
        </span>
      </h5>
      {/* Add Capa Menu On Timeline Page */}
      <h5>
        <span style={!PROGRESS_CAPA && isCapaPresent ? { color: "green" } : undefined}>
          CAPA
        </span>
        <span
          className={`text-${
            PROGRESS_CAPA ? "" : !PROGRESS_CAPA && isCapaPresent ? "success" : "danger"
          }`}
          style={PROGRESS_CAPA ? { color: "#2bb0e5" } : undefined}
        >
          {PROGRESS_CAPA ? (
            <CgSandClock />
          ) : !PROGRESS_CAPA && isCapaPresent ? (
            <MdCheckCircle />
          ) : (
            <MdCancel />
          )}
        </span>
      </h5>
    </li>
  );
};

export const InvestigationRightData = ({
  witnessStatementRequired,
  rootCauseAnalysisRequired,
  capaRequired,
  evidencesRequired,
  investigationCompletionDate,
  incidentStatus,
}) => {
  const PROGRESS_BY_STATUS = !!(
    incidentStatus === incidentStatuses.investigationCompleted
  );
  return (
    <li className="secInfo ml-5 pl-5">
      <h5>
        <span
          style={
            !PROGRESS_BY_STATUS && witnessStatementRequired
              ? { color: "green" }
              : undefined
          }
        >
          Witness Statement Required
        </span>
        <span
          className={`text-${
            PROGRESS_BY_STATUS
              ? ""
              : !PROGRESS_BY_STATUS && witnessStatementRequired
              ? "success"
              : "danger"
          }`}
          style={PROGRESS_BY_STATUS ? { color: "#2bb0e5" } : undefined}
        >
          {PROGRESS_BY_STATUS ? (
            <CgSandClock />
          ) : !PROGRESS_BY_STATUS && witnessStatementRequired ? (
            <MdCheckCircle />
          ) : (
            <MdCancel />
          )}
        </span>
      </h5>
      <h5>
        <span
          style={
            !PROGRESS_BY_STATUS && rootCauseAnalysisRequired
              ? { color: "green" }
              : undefined
          }
        >
          Root Cause Analysis Performed
        </span>
        <span
          className={`text-${
            PROGRESS_BY_STATUS
              ? ""
              : !PROGRESS_BY_STATUS && rootCauseAnalysisRequired
              ? "success"
              : "danger"
          }`}
          style={PROGRESS_BY_STATUS ? { color: "#2bb0e5" } : undefined}
        >
          {PROGRESS_BY_STATUS ? (
            <CgSandClock />
          ) : !PROGRESS_BY_STATUS && rootCauseAnalysisRequired ? (
            <MdCheckCircle />
          ) : (
            <MdCancel />
          )}
        </span>
      </h5>

      <h5>
        <span style={capaRequired ? { color: "green" } : undefined}>CAPA Required</span>
        <span
          className={`text-${
            capaRequired === null ? "" : capaRequired ? "success" : "danger"
          }`}
          style={capaRequired === null ? { color: "#2bb0e5" } : undefined}
        >
          {capaRequired === null ? (
            <CgSandClock />
          ) : capaRequired ? (
            <MdCheckCircle />
          ) : (
            <MdCancel />
          )}
        </span>
      </h5>
      <h5>
        <span
          style={
            !PROGRESS_BY_STATUS && evidencesRequired ? { color: "green" } : undefined
          }
        >
          Evidence Required
        </span>
        <span
          className={`text-${
            PROGRESS_BY_STATUS
              ? ""
              : !PROGRESS_BY_STATUS && evidencesRequired
              ? "success"
              : "danger"
          }`}
          style={PROGRESS_BY_STATUS ? { color: "#2bb0e5" } : undefined}
        >
          {PROGRESS_BY_STATUS ? (
            <CgSandClock />
          ) : !PROGRESS_BY_STATUS && evidencesRequired ? (
            <MdCheckCircle />
          ) : (
            <MdCancel />
          )}
        </span>
      </h5>
    </li>
  );
};
